import React from 'react';
export function MainProductMockup({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`relative w-full max-w-md mx-auto aspect-square ${className}`} data-id="element-10">
      <svg viewBox="0 0 400 400" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full drop-shadow-2xl" data-id="element-11">
        {/* Background Glow */}
        <circle cx="200" cy="200" r="150" fill="#f6cddb" opacity="0.3" filter="blur(40px)" data-id="element-12" />

        {/* Bottom Book */}
        <g transform="translate(40, 220) rotate(-15)" data-id="element-13">
          <rect x="0" y="0" width="260" height="340" rx="8" fill="#f8ede6" stroke="#d7a892" strokeWidth="2" data-id="element-14" />
          <rect x="10" y="0" width="20" height="340" fill="#d7a892" opacity="0.5" data-id="element-15" />
          <path d="M 30 0 L 30 340" stroke="#d7a892" strokeWidth="1" data-id="element-16" />
        </g>

        {/* Middle Book */}
        <g transform="translate(80, 150) rotate(5)" data-id="element-17">
          <rect x="0" y="0" width="260" height="340" rx="8" fill="#eae3e8" stroke="#b99bb0" strokeWidth="2" data-id="element-18" />
          <rect x="10" y="0" width="20" height="340" fill="#b99bb0" opacity="0.5" data-id="element-19" />
          <path d="M 30 0 L 30 340" stroke="#b99bb0" strokeWidth="1" data-id="element-20" />
        </g>

        {/* Top Book (Main Cover) */}
        <g transform="translate(60, 40)" data-id="element-21">
          <rect x="0" y="0" width="280" height="360" rx="12" fill="#fff" stroke="#f6cddb" strokeWidth="2" data-id="element-22" />
          <rect x="0" y="0" width="280" height="360" rx="12" fill="url(#coverGradient)" data-id="element-23" />

          {/* Spine */}
          <rect x="0" y="0" width="24" height="360" rx="4" fill="#7b1a38" data-id="element-24" />
          <path d="M 24 0 L 24 360" stroke="#4a0d20" strokeWidth="1" data-id="element-25" />

          {/* Cover Content */}
          <rect x="40" y="30" width="210" height="300" rx="4" fill="#fff" opacity="0.95" data-id="element-26" />
          <text x="145" y="80" fontFamily="Playfair Display" fontSize="28" fontWeight="700" fill="#3a1024" textAnchor="middle" data-id="element-27">
            DANZA
          </text>
          <text x="145" y="115" fontFamily="Playfair Display" fontSize="28" fontWeight="700" fill="#3a1024" textAnchor="middle" data-id="element-28">
            INFANTIL
          </text>
          <text x="145" y="160" fontFamily="Poppins" fontSize="42" fontWeight="800" fill="#7b1a38" textAnchor="middle" data-id="element-29">
            360
          </text>

          <rect x="65" y="190" width="160" height="2" fill="#f6cddb" data-id="element-30" />
          <text x="145" y="220" fontFamily="Poppins" fontSize="12" fontWeight="500" fill="#c78932" textAnchor="middle" data-id="element-31">
            EL SISTEMA COMPLETO
          </text>
          <text x="145" y="240" fontFamily="Poppins" fontSize="10" fill="#c78932" textAnchor="middle" data-id="element-32">
            PARA PROFESORAS
          </text>

          <circle cx="145" cy="285" r="20" fill="#fdf3f6" opacity="0.8" data-id="element-33" />
          <path d="M145 275 L155 290 L135 290 Z" fill="#c78932" data-id="element-34" />
        </g>

        <defs data-id="element-35">
          <linearGradient id="coverGradient" x1="0" y1="0" x2="280" y2="360" gradientUnits="userSpaceOnUse" data-id="element-36">
            <stop stopColor="#fdf7f2" data-id="element-37" />
            <stop offset="1" stopColor="#fdf3f6" data-id="element-38" />
          </linearGradient>
        </defs>
      </svg>
    </div>;
}
export function BonusMockup({
  id,
  icon,
  colorClass = 'wine'
}: {
  id: number;
  icon: React.ReactNode;
  colorClass?: string;
}) {
  const colors: Record<string, {
    bg: string;
    stroke: string;
    text: string;
    spine: string;
  }> = {
    wine: {
      bg: '#8e1b3e',
      stroke: '#9b1e42',
      text: '#fdf3f6',
      spine: '#7b1a38'
    },
    cream: {
      bg: '#d7a892',
      stroke: '#e5c5b4',
      text: '#fdf7f2',
      spine: '#c78e73'
    },
    plum: {
      bg: '#633d57',
      stroke: '#7c506f',
      text: '#f6f3f5',
      spine: '#523047'
    },
    gold: {
      bg: '#c78932',
      stroke: '#d3a152',
      text: '#fbf8f1',
      spine: '#b86e27'
    }
  };
  const c = colors[colorClass] || colors.wine;
  return <div className="relative w-full max-w-[180px] mx-auto aspect-[2/3] drop-shadow-xl transition-transform hover:-translate-y-2 duration-300" data-id="element-39">
      <svg viewBox="0 0 240 360" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full rounded-r-lg rounded-l-sm" data-id="element-40">
        {/* Main Cover */}
        <rect x="0" y="0" width="240" height="360" rx="4" fill={c.bg} data-id="element-41" />

        {/* Spine */}
        <rect x="0" y="0" width="16" height="360" fill={c.spine} opacity="0.8" data-id="element-42" />
        <path d="M 16 0 L 16 360" stroke="rgba(255,255,255,0.1)" strokeWidth="1" data-id="element-43" />

        {/* Top Left Icon Area */}
        <g transform="translate(32, 32)" data-id="element-44">
          {/* We'll overlay the React node icon here via HTML positioning, but we can leave space */}
        </g>

        {/* Bonus Number */}
        <text x="32" y="140" fontFamily="Poppins" fontSize="24" fontWeight="600" fill={c.text} textAnchor="start" data-id="element-45">
          Bonus {id}
        </text>

        {/* Divider */}
        <rect x="32" y="280" width="176" height="1" fill={c.text} opacity="0.3" data-id="element-46" />

        {/* Brand Name */}
        <text x="32" y="320" fontFamily="Poppins" fontSize="10" fontWeight="600" letterSpacing="0.1em" fill={c.text} opacity="0.9" textAnchor="start" data-id="element-47">
          DANZA INFANTIL 360™
        </text>
      </svg>
      {/* HTML Overlay for Icon */}
      <div className="absolute top-6 left-8 w-8 h-8 flex items-center justify-center" style={{
      color: c.text
    }} data-id="element-48">
        {icon}
      </div>
    </div>;
}